<template lang="pug">
  .analise(v-if="cadastro !== undefined")
    validation-observer(ref='validation' tag='form')
      el-card(shadow="hover",v-if="cadastro").card-collapse
        template
          app-dados-responsavel(
            :responsavel="cadastro.responsavel"
            :isCadastroPendente="true"
            :cadastroGeo="cadastro"
          )
          app-documentos(
            aba="Georreferenciamento",
            :isAnalise="false",
            idUploadDocumento="documentoGeorreferenciamento",
            titulo="Georreferenciamento",
            :maxSize='25000',
            :valid-extensions="extensoes",
            :documentos="cadastro.documentos",
            :tiposDocumentos="tipoDocumentosGeomensor",
            :tiposDocumentosObrigatorios="tipoDocumentosGeomensorObrigatorios",
            :pecasTecnicas="true",
            :observer="this.$refs.validation",
            @mudaTipo="mudaTipo",
            @setDadosPlanilha="setDadosPlanilha"
          )
      app-buttons-cadastro(
        :isUltimoPasso="isUltimoPasso",
        :isPrimeiroPasso="!isUltimoPasso",
        :showButtonSalvar="true",
        :showButtonProximo="true",
        @proximo="proximo",
        @finalizar="finalizar",
        @cancelar="cancelar",
        @salvar="salvar",
        @voltar="voltar"
      )
</template>
<script>
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppAnexo from '@/components/AppAnexo'
import axios from '@/utils/api'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions, mapGetters } from 'vuex'
import AppDivider from '@/components/AppDivider'
import AppDocumentos from '../central/components/cadastro/AppDocumentos.vue'
import AppDadosResponsavel from '@/components/shared/AppDadosResponsavel'
import AppLabel from '@/components/AppLabel'

const regrasAnalise = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const { pegarResponsavel } = regrasAnalise.cadastro

export default {
  components: {
    AppButtonsCadastro,
    AppAnexo,
    AppDivider,
    AppLabel,
    AppDocumentos,
    AppDadosResponsavel
  },

  mixins: [AppNotificacao],

  props: {
    idCadastroGeo: {
      required: false
    }
  },

  data () {
    return {
      cadastro: undefined,
      usuario: null,
      tipoDocumentosGeomensor: [],
      tipoDocumentosGeomensorObrigatorios: [],
      extensoes: ['pdf', 'jpeg', 'png', 'docx', 'xls', 'xlsx', 'ods', 'zip', 'rar', 'jpg', 'doc'],
      isUltimoPasso: true
    }
  },

  methods: {
    ...mapActions({
      getCadastroGeo: 'analiseGeo/getCadastroGeo',
      salvarCadastroGeo: 'analiseGeo/salvar',
      findTiposDocumentoTipoProcesso: 'tipoDocumento/findTiposDocumentoTipoProcesso'
    }),
    ...mapGetters({
      getUsuario: 'auth/usuarioLogado'
    }),
    async montarTela () {
      if (this.idCadastroGeo) {
        this.cadastro = await this.getCadastroGeo(this.idCadastroGeo)
        this.formataDocumento()
      } else {
        this.cadastro = {
          interessadoCpfCnpj: '',
          documentos: [],
          responsavel: await this.carregarResponsavel()
        }
      }
    },

    async carregarResponsavel () {
      if (pegarResponsavel) {
        return axios({
          method: 'GET',
          url: `responsavelProcesso/findByIdUsuario/${this.usuario.id}`
        })
      }
      return {
        nome: '',
        codigoIncra: '',
        creaRnp: '',
        formacao: ''
      }
    },
    mudaTipo (opcao) {
      switch (opcao.tipo) {
        case 'DRD_DRL':
        case 'RELATORIO_TECNICO_DE_EXECUCAO_DO_GEOPROCESSAMENTO':
        case 'ART_TRT':
        case 'CARTAS_CONFRONTANTES':
        case 'CERTIDAO_PUBLICIDADE':
        case 'EDITAL_MEDICAO':
          this.extensoes = ['pdf']
          break
        case 'RELATORIO_DE_PROCESSAMENTO':
        case 'ARQUIVOS_GNSS':
          this.extensoes = ['zip']
          break
        case 'TABELA_DADOS_CARTOGRAFICOS':
          this.extensoes = ['ods', 'xlsx']
          break
        case 'OUTROS_GEOMENSOR':
          this.extensoes = ['pdf', 'jpeg', 'png', 'jpg', 'doc', 'docx', 'xls', 'xlsx', 'ods', 'zip', 'rar']
          break
      }
    },
    async setDadosPlanilha (valor) {
      this.cadastro.denominacaoImovel = valor.denominacao
      this.cadastro.jsonPlanilha = valor.jsonPlanilha
      this.cadastro.tipoPlanilha = valor.tipoPlanilha
    },
    async finalizar () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERROS_ANALISE
        )
        return
      }
      try {
        this.confirmBox(
          this.$messages.FINALIZAR_ANALISE,
          this.$messages.TITULO_WARNING,
          async () => {
            this.cadastro.isFinalize = true
            await this.execucao('Cadastro finalizado.')
            this.$router.push({name: 'CADASTROS_PENDENTES_GEORREFERENCIAMENTO'})
          }
        )
      } catch (error) {
        const erroValidacao = error.status === 422
        const tipoErro = !erroValidacao
          ? this.$messages.TIPO_ERROR
          : this.$messages.TIPO_WARNING
        const tituloErro = !erroValidacao
          ? this.$messages.TITULO_ERROR
          : this.$messages.TITULO_WARNING
        const messagemDeErro = Array.isArray(error.erros)
          ? error.erros.join(';')
          : 'Houve um erro ao finalizar a analise.'
        this.showNotificacao(tipoErro, tituloErro, messagemDeErro)
      }
    },

    async proximo () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERROS_ANALISE
        )
        return
      }
      await this.salvar()
    },

    deleteAnexo (documento) {
      if (documento.id) {
        const index = this.anexos.indexOf(
          this.anexos.find(a => a.id === documento.id)
        )
        this.anexos.splice(index, 1)
      } else {
        const index = this.anexos.indexOf(
          this.anexos.find(a => a.key === documento.key)
        )
        this.anexos.splice(index, 1)
      }
    },
    cancelar () {
      this.$router.push({name: 'CADASTROS_PENDENTES_GEORREFERENCIAMENTO'})
    },
    async salvar () {
      try {
        this.cadastro.isFinalize = false
        await this.execucao('Cadastro salvo!')
      } catch (error) {
        const messagemDeErro = Array.isArray(error.erros)
          ? error.erros.join(';')
          : 'Houve um erro ao salvar a cadastro.'
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          messagemDeErro
        )
      }
    },
    voltar () {
      this.$router.push({name: 'CADASTROS_PENDENTES_GEORREFERENCIAMENTO'})
    },
    async execucao (titulo) {
      this.formataDocumentoEntity()
      const response = await this.salvarCadastroGeo(this.cadastro)
      this.showNotificacao(
        this.$messages.TIPO_SUCCESS,
        this.$messages.TITULO_SUCCESS,
        titulo
      )
      if (!this.idCadastroGeo) {
        this.$router.push({
          name: '/gerar-geo-cadastro-pendente',
          params: {
            idCadastroGeo: response.id
          }
        }).then(() => {
          this.$router.go(0) // Recarrega a página para editar o cadastro com idCadastroGeo setado
        })
      }
      this.montarTela()
    },
    formataDocumento () {
      this.cadastro.documentos = this.cadastro.documentos.map(documento => ({
        id: documento.id,
        fileKey: documento.key,
        fileName: documento.nome,
        caminho: documento.caminho,
        tipoDocumento: {
          codigo: documento.tipo.codigo,
          id: documento.tipo.id,
          descricao: documento.tipo.descricao,
          tipo: documento.tipo.codigo
        }
      }))
    },
    formataDocumentoEntity () {
      this.cadastro.documentos = this.cadastro.documentos.map(documento => {
        return {
          id: documento.id,
          caminho: documento.caminho,
          key: documento.fileKey,
          nome: documento.fileName,
          tipo: documento.tipoDocumento
        }
      })
    }
  },

  async created () {
    this.usuario = await this.getUsuario()
    await this.montarTela()
    this.tipoDocumentosGeomensor = await this.findTiposDocumentoTipoProcesso({
      url: 'geo',
      tipo: 'NAO_ONEROSO'
    })

    this.tipoDocumentosGeomensorObrigatorios = this.tipoDocumentosGeomensor.filter(f => !['OUTROS_GEOMENSOR', 'RELATORIO_DE_PROCESSAMENTO', 'DRD_DRL'].includes(f.codigo))
  }
}
</script>
<style lang="scss">

.analise {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.card-collapse {
  border-radius: 10px;
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/GerarGeoCadastroPendente.vue